module.exports = "<svg id=\"e60f28fc-5548-41ef-b761-2c9c175d5f0c\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49.79 16.22\"><defs><style> .a121cd49-0dba-4b73-ab0c-0b9e89c8ec40 { } </style></defs><polygon class=\"a121cd49-0dba-4b73-ab0c-0b9e89c8ec40\" points=\"35.37 0 36.24 0.49 48.24 7.24 49.79 8.11 48.24 8.98 36.24 15.73 35.37 16.22 34.39 14.48 35.26 13.99 43.93 9.11 0 9.11 0 7.11 43.93 7.11 35.26 2.23 34.39 1.74 35.37 0\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow.svg
// module id = 7Hhe
// module chunks = 1